export const NO_AUTH = 0;
export const PARTIAL_AUTH = 1;
export const FULL_AUTH = 2;

export const isValidAuthStatus = (status) => {
    return status in [NO_AUTH, PARTIAL_AUTH, FULL_AUTH];
};
